'use client';

import {
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Icon,
  Separator,
  Text,
} from '@/_components';
import type { EnterpriseFormProps } from './EnterpriseForm.types';
import type { FC } from 'react';

export const EnterpriseForm: FC<EnterpriseFormProps> = ({
  title,
  description,
  items,
  onClick,
}) => {
  return (
    <>
      <Flex isColumn={true} padding={12}>
        <Flex isYCentered={true} gap={4}>
          <Icon size={24} color="accent" name="lock" internalIconWidth="fill" />
          <Text type="div">You have not purchased this feature</Text>
        </Flex>
        <Heading level={3} weight="semi-bold">
          Contact us to activate <span className="text-accent">{title}</span>
        </Heading>
      </Flex>
      <Separator />
      <Flex isColumn={true} padding={12} gap={8}>
        {!!description && <Text fontWeight="semi-bold">{description}</Text>}
        <Flex isColumn={true} gap={6}>
          {items?.map((item, key) => {
            return (
              <Flex isYCentered={true} gap={4} key={key}>
                <Icon
                  size={16}
                  name="check-circle"
                  internalIconWidth="fill"
                  color="success"
                />
                <Text type="small">{item}</Text>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
      <Separator />
      <Flex isColumn={true} padding={12} gap={12}>
        <ButtonGroup align="center" isFullWidth={true} isSameLine={true}>
          <Button
            intent="secondary"
            value="Contact Sales"
            onClick={() => onClick('contact-sales')}
          />
          <Button
            intent="primary"
            value="Book a Demo"
            onClick={() => onClick('book-a-demo')}
          />
        </ButtonGroup>
      </Flex>
    </>
  );
};
